import { Field } from '@kanda-libs/ks-component-ts';

import Container from './FinancePlanBuilder-container';
import FinancePlan from '../FinancePlan';

const ViewComponent = ({}) => (
  <Container>
    {({ builderProps, planProps }) => (
      <>
        <Field.BuildFinancePlan {...builderProps} />
        <div className="mb-4" />
        <FinancePlan {...planProps} />
      </>
    )}
  </Container>
);

ViewComponent.displayName = 'FinancePlanBuilder-view';

export default ViewComponent;
